var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clearfix" }, [
    _c(
      "a",
      {
        staticClass: "tender-back-link",
        on: {
          click: function ($event) {
            return _vm.doNav()
          },
        },
      },
      [
        _c("i", {
          staticClass: "fa fa-angle-left",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(_vm._s(_vm.$t("home"))),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }